import apiUrls from "../../api";

export interface ITargetObject {
  table?: string;
  id?: number;
  commit_hash?: string;
  blockadeLabImageId?: string;
  thumbnailUrl?: string;
  imageUrl?: string;
  faultyImageId?: string;
  errorMessage?: string;
}

export interface IEventMessage {
  issuedFromEnv: number;
  issuedFromUser: number;
  action: string;
  actionTsInMs: number;
  targetObjects: ITargetObject[];
}

let ES: EventSource | null = null;

export interface SSEHandlers {
  onopen?: () => void;
  onerror?: (e: Event) => void;
  onmessage?: (event: MessageEvent) => void;
}

const InitEventSource = (jwt: string, handlers?: SSEHandlers) => {
  if (ES && ES.readyState !== EventSource.CLOSED) {
    ES.close();
  }

  ES = new EventSource(`${apiUrls.sseStream}?auth=${jwt}`);

  if (handlers) {
    if (handlers.onopen) ES.onopen = handlers.onopen;
    if (handlers.onerror) ES.onerror = handlers.onerror;
    if (handlers.onmessage) ES.onmessage = handlers.onmessage;
  }

  return ES;
};

const getEventSource = () => ES;

const closeEventSource = () => {
  if (ES && ES.readyState !== EventSource.CLOSED) {
    ES.close();
  }
};

export { InitEventSource, getEventSource, closeEventSource, ES };
